import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export interface GameEngineVersion {
    id: number;
    version: string;
    engine: GameEngine;
}

export interface GameEngine {
    id: number;
    version: string;
    schema: any;
}

export function gameEngines(state: GameEngineVersion[] = [], action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ENGINES_SUCCESS:
            const results = action.payload.gameEngines.results.sort((a, b) => {
                if (a.version < b.version) {
                    return 1;
                }
                if (a.version > b.version) {
                    return -1;
                }
                return 0;
            });
            return results;

        default:
            return state;
    }
}

export function gameEnginesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ENGINES:
            return true;

        case GamesActionTypes.GET_GAME_ENGINES_FAIL:
        case GamesActionTypes.GET_GAME_ENGINES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function enginesSchemas(state: any = null, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ENGINES_SCHEMAS_SUCCESS:
            return action.payload.enginesSchemas;
        default:
            return state;
    }
}

export function enginesSchemasLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ENGINES_SCHEMAS:
            return true;

        case GamesActionTypes.GET_GAME_ENGINES_SCHEMAS_FAIL:
        case GamesActionTypes.GET_GAME_ENGINES_SCHEMAS_SUCCESS:
            return false;

        default:
            return state;
    }
}
